import { toast } from 'react-toastify';

const getZatcaValidationMessage = (data) => {
    const errors = data?.validationResults?.errorMessages;
    if (!Array.isArray(errors) || errors.length === 0) return "";

    return errors
      .map((error) => error?.message || error?.category || error?.code)
      .filter(Boolean)
      .join(", ");
};

export function getErrorMessage(err, fallback = "Something went wrong.") {
    const data = err?.response?.data;
    if (typeof data === "string" && data.trim()) return data;

    const message =
      data?.message ||
      data?.error ||
      getZatcaValidationMessage(data) ||
      getZatcaValidationMessage(data?.data);

    if (typeof message === "string" && message.trim()) return message;
    if (message && typeof message === "object") {
      return getZatcaValidationMessage(message) || fallback;
    }

    return fallback;
}

export function showToast(type, message) {
    if (type == 'success') {
      toast.success(message , {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
    });
    } else if (type == 'error') {
        toast.error(message , {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
        });
    } else if (type == 'info') {
        toast.info(message , {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
        });
    }

}
